import { useMemo } from 'react';
import { DetailedIconEmail } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation-10';

import ScreeningPreferencesTextButton from '../../../ScreeningPreferencesTextButton';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptySimpleCard,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';

type Props = {
  showScreeningCriteriaCTA?: boolean;
  isScreeningCriteriaSet?: boolean;
  screeningCriteriaPath?: string;
};

const EmptyInquiriesCard = ({ showScreeningCriteriaCTA, isScreeningCriteriaSet, screeningCriteriaPath }: Props) => {
  const renderBodyContent = useMemo(() => {
    return showScreeningCriteriaCTA ? (
      <>
        <Paragraph css={{ marginBottom: '600' }}>
          When a renter contacts you, help make a good first impression by responding within 24 hours. While you wait,
          get ready to attract the right renters for you.
        </Paragraph>

        <Paragraph textStyle="body-sm">
          <ScreeningPreferencesTextButton />
        </Paragraph>
      </>
    ) : (
      `When a renter contacts you, try to respond within 24 hours. Replying to every inquiry as quickly as you can
      will help give renters a good impression of you and create a better experience for Zillow users.`
    );
  }, [showScreeningCriteriaCTA]);

  return (
    <StyledEmptySimpleCard
      data-testid="EmptyInquiriesCard"
      css={{ marginBottom: '400', paddingInline: '600', paddingBlock: '1000' }}
    >
      <StyledEmptyStateContainer data-testid="EmptyStateContainer">
        <StyledIconContainer>
          <DetailedIconEmail />
        </StyledIconContainer>

        <EmptyStateTitleText asChild>
          <h4>No inquiries yet</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild>
          <p>{renderBodyContent}</p>
        </EmptyStateBodyText>
      </StyledEmptyStateContainer>
    </StyledEmptySimpleCard>
  );
};

export default EmptyInquiriesCard;
